import React, { FC } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { V1_ACCENT } from './theme';

// ============================================================================
// Shared error state for the "Documentation history" panel across the V1 detail
// dialogs. When the events fetch fails (e.g. backend can't reach the DB), the
// query keeps its last-good cache and RTK only sets `error` — so without this
// the panel silently renders stale rows as if they were this card's. Callers
// render this instead of the timeline whenever the query `isError`.
// ============================================================================

export const DocHistoryError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
  <Box sx={{ py: 4, textAlign: 'center' }}>
    <Typography sx={{ fontSize: 14, color: '#6b6b70', mb: 1.75 }}>
      We couldn&rsquo;t load this history. Please try again or{' '}
      <Link component={RouterLink} to="/contact">contact support</Link>.
    </Typography>
    <Button
      onClick={onRetry}
      variant="outlined"
      size="small"
      sx={{ borderRadius: '20px', textTransform: 'none', borderColor: V1_ACCENT, color: V1_ACCENT }}
    >
      Try again
    </Button>
  </Box>
);
